import { render, staticRenderFns } from "./EditAddressAndSocialMedia.vue?vue&type=template&id=7840a870"
import script from "./EditAddressAndSocialMedia.vue?vue&type=script&lang=js"
export * from "./EditAddressAndSocialMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports